import {baseDevConfig} from '../base/dev.config';
import {cnetLocalConfig} from './local.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const cnetDevConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseDevConfig, cnetLocalConfig,  {
  environmentName: "Cnet Development Environment",
  hubApi: "https://testcms.cnet.com",
  ionicEnvName: 'dev',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cnet/dev.config.ts